import React from "react"
import { PropertyNew } from "./PropertyNew"
import { usePropertyNewForm } from "../../hooks/usePropertyNewForm/usePropertyNewForm"

type Props = {
  className?: string
}

export const PropertyNewContainer: React.VFC<Props> = () => {
  const {
    formState,
    handleChange,
    handleUrlSubmit,
    handleMultiChange,
    handleUrlChange,
    handleImageSubmit,
    handlePropertySubmit,
    handleRunNinja,
    handleUserIdChange,
  } = usePropertyNewForm()

  return (
    <PropertyNew
      formState={formState}
      handleRunNinja={handleRunNinja}
      handleChange={handleChange}
      handleUrlChange={handleUrlChange}
      handleUrlSubmit={handleUrlSubmit}
      handleMultiChange={handleMultiChange}
      handleImageSubmit={handleImageSubmit}
      handlePropertySubmit={handlePropertySubmit}
      handleUserIdChange={handleUserIdChange}
    />
  )
}
